// extracted by css-extract-rspack-plugin
export default {"paperContainer":"src-domain-components-simplified-block-device-modal-SimplifiedBlockDeviceModal-module__paperContainer-EI2h57","modalActions":"src-domain-components-simplified-block-device-modal-SimplifiedBlockDeviceModal-module__modalActions-gdUiFS","customActionsClassName":"src-domain-components-simplified-block-device-modal-SimplifiedBlockDeviceModal-module__customActionsClassName-AfE9rs"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"paperContainer\":\"src-domain-components-simplified-block-device-modal-SimplifiedBlockDeviceModal-module__paperContainer-EI2h57\",\"modalActions\":\"src-domain-components-simplified-block-device-modal-SimplifiedBlockDeviceModal-module__modalActions-gdUiFS\",\"customActionsClassName\":\"src-domain-components-simplified-block-device-modal-SimplifiedBlockDeviceModal-module__customActionsClassName-AfE9rs\"}";
        // 1792611263184
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  